import React, { useCallback } from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import PropTypes from 'prop-types';
import metadata from './MLCoveragePackageLevelInfoModal.metadata.json5';
import './MLCoveragePackageLevelInfoModal.messages';

const MLCoveragePackageLevelInfoModal = (props) => {
    const {
        isPersonalAuto,
        isHomeowners,
        isRenters,
        isCondo
    } = props;

    const getGrandProtectAutoCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Auto Extra', value: 'Required' },
            { type: 'Diminishing Deductible ', value: 'Required If Comprehensive or Collision is present on any vehicle' },
            { type: 'Glass Deductible Waiver', value: 'Required If Comprehensive is present' },
            { type: 'New Vehicle Replacement', value: 'Required If vehicle is 1 year old and collision or comprehensive is present (not including trailers)' },
            { type: 'Rental Car Reimbursement', value: 'Required If Comprehensive or Collision is present (not including trailers)' },
            { type: 'Roadside Assistance', value: 'Required If Comprehensive or Collision is present (not including trailers)' },
            { type: 'Travel Package', value: 'Required' },
            { type: 'Worldwide Liability', value: 'Required' },
            { type: 'Collision', value: 'Required on at least one vehicle (not including trailers)' },
            { type: 'Comprehensive', value: 'Required on at least one vehicle (not including trailers)' }
        ];
    }, []);

    const getEnhancedPlusAutoCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Auto Extra', value: 'Required only if at least one vehicle has collision and comprehensive (not including trailer). Auto Extra is not required if collision and comprehensive are not selected on at least one vehicle (not including trailer).' },
            { type: 'Diminishing Deductible ', value: 'Required only if at least one vehicle has collision and comprehensive (not including trailer). Diminishing Deductible is not required if collision and comprehensive are not selected on at least one vehicle (not including trailer).' }
        ];
    }, []);

    const getValuePlusCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Any policy that does not qualify for either GrandProtect or Enhanced Plus as noted above will be slotted into Value Plus.' }
        ];
    }, []);

    const getGrandProtectHomeownersCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Building Property Loss Settlement', value: 'Blanket Property Guaranteed Rebuild' },
            { type: 'Back Up of Sewers, Drains and Sump', value: '$10,000 & up' },
            { type: 'Personal Injury', value: 'Present' },
            { type: 'Additional Features', value: 'Elite' },
            { type: 'Coverage A Perils', value: 'Comprehensive' },
            { type: 'Coverage C Perils', value: 'Comprehensive' }
        ];
    }, []);

    const getEnhancedPlusHomeownersCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Personal Property Loss Settlement', value: 'Replacement Cost on Contents or Blanket Property Replacement Cost' },
            { type: 'Additional Features', value: 'Better, Best, or Elite' },
            { type: 'Coverage A Perils', value: 'Comprehensive' },
            { type: 'Coverage C Perils', value: 'Broad Named or Comp' }
        ];
    }, []);

    const getGrandProtectCondoCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Building Property Loss Settlement', value: 'Blanket Property Replacement Cost' },
            { type: 'Personal Injury', value: 'Present' },
            { type: 'Additional Features', value: 'Elite' },
            { type: 'Coverage A Perils', value: 'Comprehensive' },
            { type: 'Coverage C Perils', value: 'Comprehensive' },
            { type: 'Loss Assessment', value: '$10K minimum' }
        ];
    }, []);

    const getEnhancedPlusCondoCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Personal Property Loss Settlement', value: 'Replacement Cost on Contents or Blanket Property Replacement Cost' },
            { type: 'Additional Features', value: 'Better, Best, or Elite' },
            { type: 'Coverage A Perils', value: 'Comprehensive' },
            { type: 'Coverage C Perils', value: 'Broad Named or Comp' },
            { type: 'Loss Assessment', value: '$5K minimum' }
        ];
    }, []);

    const getGrandProtectRentersCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Building Property Loss Settlement', value: 'Blanket Property Replacement Cost' },
            { type: 'Personal Injury', value: 'Present' },
            { type: 'Additional Features', value: 'Elite' },
            { type: 'Coverage A Perils', value: 'Comprehensive' },
            { type: 'Coverage C Perils', value: 'Comprehensive' }
        ];
    }, []);

    const getEnhancedPlusRentersCoveragePackageLevelInfo = useCallback(() => {
        return [
            { type: 'Personal Property Loss Settlement', value: 'Replacement Cost on Contents or Blanket Property Replacement Cost' },
            { type: 'Additional Features', value: 'Better, Best, or Elite' },
            { type: 'Coverage A Perils', value: 'Comprehensive' },
            { type: 'Coverage C Perils', value: 'Broad Named or Comp' }
        ];
    }, []);

    const getGrandProtectCoveragePackageLevelInfo = () => {
        if (isPersonalAuto) {
            return getGrandProtectAutoCoveragePackageLevelInfo()
        }
        if (isHomeowners) {
            return getGrandProtectHomeownersCoveragePackageLevelInfo()
        }
        if (isCondo) {
            return getGrandProtectCondoCoveragePackageLevelInfo()
        }
        if (isRenters) {
            return getGrandProtectRentersCoveragePackageLevelInfo()
        }
    }

    const getEnhancedPlusCoveragePackageLevelInfo = () => {
        if (isPersonalAuto) {
            return getEnhancedPlusAutoCoveragePackageLevelInfo()
        }
        if (isHomeowners) {
            return getEnhancedPlusHomeownersCoveragePackageLevelInfo()
        }
        if (isCondo) {
            return getEnhancedPlusCondoCoveragePackageLevelInfo()
        }
        if (isRenters) {
            return getEnhancedPlusRentersCoveragePackageLevelInfo()
        }
    }

    const overrides = {
        mlGrandProtectCoveragePackageLevelTableRow: {
            data: getGrandProtectCoveragePackageLevelInfo()
        },
        mlEnhancedPlusCoveragePackageLevelTableRow: {
            data: getEnhancedPlusCoveragePackageLevelInfo()
        },
        mlValuePlusCoveragePackageLevelTableRow: {
            data: getValuePlusCoveragePackageLevelInfo()
        }
    };

    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {}
    };
    
    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLCoveragePackageLevelInfoModal.propTypes = {
    isPersonalAuto: PropTypes.bool,
    isHomeowners: PropTypes.bool,
    isRenters: PropTypes.bool,
    isCondo: PropTypes.bool
};

export default MLCoveragePackageLevelInfoModal;
